// extracted by mini-css-extract-plugin
module.exports = {"table-container":"FailedPrints_table-container__2OkzE","table":"FailedPrints_table__2pdgD"};